import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { KEYWORD_SWITCH_SOURCE_HANDLES } from '../keywordSwitchHandles';
import { KeywordSwitchNodeView } from '../views/KeywordSwitchNode';
import { KeywordSwitchSettings } from '../settings/KeywordSwitchSettings';

export const keywordSwitchDefinition: NodeDefinition<'keywordSwitch'> = {
  label: 'Keyword Switch',
  showInPalette: true,
  paletteColor: 'bg-teal-100 border-teal-500 text-teal-700',
  miniMapColor: '#14b8a6',
  defaultData: {
    label: 'Keyword Switch',
    keyword1: '',
    keyword2: '',
  },
  view: KeywordSwitchNodeView,
  settings: KeywordSwitchSettings,
  run: (node, ctx, log) => {
    const input = String(ctx.lastValue ?? '');
    const keyword1 = typeof node.data.keyword1 === 'string' ? node.data.keyword1 : '';
    const keyword2 = typeof node.data.keyword2 === 'string' ? node.data.keyword2 : '';
    let nextHandle: string = KEYWORD_SWITCH_SOURCE_HANDLES.default;
    let branchLabel = 'どちらでもない';

    if (keyword1 !== '' && input.includes(keyword1)) {
      nextHandle = KEYWORD_SWITCH_SOURCE_HANDLES.match1;
      branchLabel = 'キーワード1';
    } else if (keyword2 !== '' && input.includes(keyword2)) {
      nextHandle = KEYWORD_SWITCH_SOURCE_HANDLES.match2;
      branchLabel = 'キーワード2';
    }

    log(`[Keyword Switch] "${input}" -> ${branchLabel}`);
    return { nextHandle, branchLabel };
  },
  help: {
    title: [t('Keyword Switch（キーワード'), r('分岐', 'ぶんき'), t('）')],
    description: [
      r('受', 'う'),
      t('け'),
      r('取', 'と'),
      t('った「ことば」の'),
      r('中', 'なか'),
      t('にキーワードが'),
      r('入', 'はい'),
      t('っているかで、'),
      r('進', 'すす'),
      t('む'),
      r('道', 'みち'),
      t('を'),
      r('選', 'えら'),
      t('びます。「キーワード1」が'),
      r('入', 'はい'),
      t('っていれば「キーワード1」へ、「キーワード2」が'),
      r('入', 'はい'),
      t('っていれば「キーワード2」へ、どちらも'),
      r('入', 'はい'),
      t('っていなければ「どちらでもない」へ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
